import React from "react";
import { LoadioContentProfileListTemplate } from "themes/administration/loadio/pages";
import { LoadioContentProfileListViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioContentProfileListViewStore(rootStore, componentProps),
    "loadioContentProfileListViewStore"
)
class LoadioContentProfileList extends React.Component {
    render() {
        return <LoadioContentProfileListTemplate {...this.props} />;
    }
}

export default LoadioContentProfileList;
